export enum packageRoutes {
  packages = 'packages',
  payment = 'payment',
}
